import type { EventPageTabEntities, RacePageTabEntities } from '.';

export const isRaceBasedEntity = (
  entities: EventPageTabEntities | RacePageTabEntities
): entities is RacePageTabEntities => 'raceId' in entities;
